import { IProjectionPagedModel, ProjectionPagedModel } from "./ProjectionPageModel"

export class PagedBaseState<T> {
    Data: IProjectionPagedModel<T>
    Searcher: any
    Page: number
    Righe: number

    constructor() {
        this.Data = new ProjectionPagedModel<T>()
    }
}
